import config from '../../../config';
import { FLAG_UPDATED_EVENT, FLAGS_API_PATH } from '../../util/flags/constants';
import { parseFlagStreamEvent } from '../../util/flags/helpers';
import { FlagEnvironment, FlagStreamEvent } from '../../util/flags/types';

let source: EventSource | null = null;

export const closeFlagStream = (): void => {
  source?.close();
  source = null;
};

export const openFlagStream = (
  environment: FlagEnvironment,
  cursor: string | undefined,
  onEvent: (event: FlagStreamEvent) => void,
): void => {
  closeFlagStream();

  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
  const url = `https://${config.gateway.url}${FLAGS_API_PATH}/${environment}/stream${query}`;

  const handle = (data: string) => {
    const event = parseFlagStreamEvent(data);

    if (event) onEvent(event);
  };

  source = new EventSource(url, { withCredentials: true });
  source.addEventListener(FLAG_UPDATED_EVENT, event => handle((event as MessageEvent).data));
  // Fallback for a server that pushes the payload without an event name
  source.onmessage = event => handle(event.data);
};
